(function() {
    'use strict';

    angular
        .module('elogbooksServices')
        .service('quoteRequestService', QuoteRequestService);

    QuoteRequestService.$inject = ['$translate', 'modulesService', 'elbSettings'];

    function QuoteRequestService($translate, modulesService, elbSettings) {
        var self = this;

        this.getStatusesAsObject = getStatusesAsObject;
        this.getQuoteStatusesAsObject = getQuoteStatusesAsObject;
        this.getQuoteStatusesAsArray = getQuoteStatusesAsArray;

        function getStatusesAsObject() {
            var statuses = [
                {
                    value: null,
                    title: $translate.instant('NONE_SELECTED')
                },
                {
                    value: 'created',
                    title: $translate.instant('QUOTE_REQUEST_STATUS_CREATED')
                },
                {
                    value: 'requested',
                    title: $translate.instant('QUOTE_REQUEST_STATUS_REQUESTED')
                },
                {
                    value: 'part_quoted',
                    title: $translate.instant('QUOTE_REQUEST_STATUS_PART_QUOTED')
                },
                {
                    value: 'quoted',
                    title: $translate.instant('QUOTE_REQUEST_STATUS_QUOTED')
                },
                {
                    value: 'rejected',
                    title: $translate.instant('QUOTE_REQUEST_STATUS_REJECTED')
                },
                {
                    value: 'accepted',
                    title: $translate.instant('QUOTE_REQUEST_STATUS_ACCEPTED')
                },
                {
                    value: 'cancelled',
                    title: $translate.instant('QUOTE_REQUEST_STATUS_CANCELLED')
                },
                {
                    value: 'expired',
                    title: $translate.instant('QUOTE_REQUEST_STATUS_EXPIRED')
                },
                {
                    value: 'declined',
                    title: $translate.instant('QUOTE_REQUEST_STATUS_DECLINED')
                },
                {
                    value: 'extension_requested',
                    title: $translate.instant('QUOTE_REQUEST_STATUS_EXTENSION_PENDING')
                },
                {
                    value: 'revision_requested',
                    title: $translate.instant('QUOTE_STATUS_REVISION_REQUESTED')
                },
                {
                    value: 'converted',
                    title: $translate.instant('QUOTE_REQUEST_STATUS_CONVERTED')
                },
            ];

            statuses.sort(function(a, b) {
                if (a.value === null) {
                    return -1;
                }

                return a.title > b.title ? 1 : (a.title < b.title ? -1 : 0);
            });

            return statuses;
        }

        var quoteStatuses = [
            'requested',
            'submitted',
            'accepted',
            'rejected',
            'cancelled',
            'expired',
            'abstained',
            'pending',
            'information_requested',
            'extension_requested',
            'value_pending_approval',
            'revision_requested',
            'value_approval_given',
            'budget_quote_submitted',
            'budget_quote_converted'
        ];

        var performanceStatisticQuoteStatuses = [
            'requested',
            'submitted',
            'accepted',
            'rejected',
            'expired',
            'pending',
            'information_requested'
        ];

        var nonFinalQuoteStatuses = [
            'requested',
            'submitted',
            'pending',
            'information_requested',
            'extension_requested',
            'value_pending_approval',
            'revision_requested'
        ];

        function isBudgetQuotesEnabled() {
            return elbSettings.getSetting('budget_quotes_exist').value || elbSettings.getSetting('budget_quotes').value;
        }

        function filterStatuses(statusList, includeBudgetQuoteStatus) {
            var includeValueApproval = modulesService.isEnabled('quote_value_approval');
            if (typeof includeBudgetQuoteStatus === 'undefined') {
                includeBudgetQuoteStatus = isBudgetQuotesEnabled();
            }

            return statusList.filter(function(quoteStatus) {
                if (quoteStatus === 'value_pending_approval' || quoteStatus === 'value_approval_given') {
                    return includeValueApproval;
                } else if (quoteStatus === 'budget_quote_submitted' || quoteStatus === 'budget_quote_converted') {
                    return !!includeBudgetQuoteStatus;
                }
                return true;
            });
        }

        function getQuoteStatusesAsObject(includeBudgetQuoteStatus) {
            var statuses = [];
            var filteredStatuses = filterStatuses(quoteStatuses, includeBudgetQuoteStatus);

            angular.forEach(filteredStatuses, function(quoteStatus) {
                statuses.push({
                    value: quoteStatus,
                    title: $translate.instant('QUOTE_STATUS_' + quoteStatus.toUpperCase())
                });
            });

            statuses.sort(function(a, b) {
                if (a.value === null) {
                    return -1;
                }

                return a.title > b.title ? 1 : (a.title < b.title ? -1 : 0);
            });

            return statuses;
        }

        function getQuoteStatusesAsArray(statuses) {
            var statusList = [];
            switch (statuses) {
                case 'all':
                    statusList = quoteStatuses;
                    break;
                case 'performancestatistic':
                    statusList = performanceStatisticQuoteStatuses;
                    break;
                case 'nonfinal':
                    statusList = nonFinalQuoteStatuses;
                    break;
                default:
                    statusList = quoteStatuses;
                    break;
            }
            return filterStatuses(statusList);
        }

        return this;
    }
})();
